var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardlistFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6 12.2C21.03 12.2 23 10.1405 23 7.6C23 5.05949 21.03 3 18.6 3C16.5498 3 14.8271 4.46599 14.3386 6.45H2.1C1.49249 6.45 1 6.96488 1 7.6C1 8.23513 1.49249 8.75 2.1 8.75H14.3386C14.8271 10.734 16.5498 12.2 18.6 12.2ZM16.4 7.6C16.4 8.87026 17.3849 9.9 18.6 9.9C19.8151 9.9 20.8 8.87026 20.8 7.6C20.8 6.32974 19.8151 5.3 18.6 5.3C17.3849 5.3 16.4 6.32974 16.4 7.6ZM1 16.8C1 14.2595 2.96995 12.2 5.4 12.2C7.45022 12.2 9.17293 13.666 9.66138 15.65H21.9C22.5075 15.65 23 16.1649 23 16.8C23 17.4351 22.5075 17.95 21.9 17.95H9.66138C9.17293 19.934 7.45022 21.4 5.4 21.4C2.96995 21.4 1 19.3405 1 16.8ZM7.6 16.8C7.6 15.5297 6.61503 14.5 5.4 14.5C4.18497 14.5 3.2 15.5297 3.2 16.8C3.2 18.0703 4.18497 19.1 5.4 19.1C6.61503 19.1 7.6 18.0703 7.6 16.8Z",
    fill: "#191B23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardlistFilter);
export default __webpack_public_path__ + "static/media/cardlist_filter.d3b2645bdd39d62922ee89f0e1b358e3.svg";
export { ForwardRef as ReactComponent };